// translate-field.ts
import { clientTranslator } from "@adornis/translation-core/client/clientTranslator.js";
var translation = clientTranslator;
var translationCache = /* @__PURE__ */ new Map();
function translateFieldName(fieldPath, translator = translation) {
  const translationCacheKey = Array.isArray(fieldPath) ? fieldPath.join(";") : fieldPath;
  const translationCacheHit = translationCache.get(translationCacheKey);
  if (translationCacheHit)
    return translationCacheHit;
  let translatedValue = translator.translate("field", ...Array.isArray(fieldPath) ? fieldPath : fieldPath.split("."));
  if (translatedValue.includes("field.")) {
    const keyPath = Array.isArray(fieldPath) ? fieldPath : fieldPath.split(".");
    translatedValue = keyPath.map((keyPart) => translator.translate("field", keyPart.split(".").slice(-1)[0])).join(" > ");
  }
  translationCache.set(translationCacheKey, translatedValue);
  return translatedValue;
}
function translateFieldConfiguration(fieldConf) {
  return fieldConf.displayName ? fieldConf.displayName : translateFieldName(fieldConf.customID ?? fieldConf.fieldName ?? "No Fieldname");
}
export {
  translateFieldConfiguration,
  translateFieldName
};
